import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      onClick={handleClick}
      className="group block"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫网免费韩漫大全`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-3 leading-relaxed">
            {comic.description}
          </p>
        </div>
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            已完结
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            新作
          </span>
        )}
      </div>
      <h3 className="font-heading font-semibold text-sm text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 line-clamp-1">{comic.author}</p>
      <div className="flex items-center gap-2 mt-1.5">
        <span className="flex items-center gap-0.5 text-xs text-accent-600">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </span>
        <span className="text-xs text-foreground-400">
          {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views} 阅读
        </span>
      </div>
    </Link>
  );
}